import { render } from "./gsrsu03030101.vue?vue&type=template&id=a21ff988&scoped=true"
import script from "./gsrsu03030101.vue?vue&type=script&lang=js"
export * from "./gsrsu03030101.vue?vue&type=script&lang=js"

import "./gsrsu03030101.vue?vue&type=style&index=0&id=a21ff988&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a21ff988"]])

export default __exports__